import i18n from '@/i18n'
import api from './api'

export const DV360_CAMPAIGN_GOAL_VALUES = {
  CAMPAIGN_GOAL_TYPE_APP_INSTALL: 'CAMPAIGN_GOAL_TYPE_APP_INSTALL',
  CAMPAIGN_GOAL_TYPE_BRAND_AWARENESS: 'CAMPAIGN_GOAL_TYPE_BRAND_AWARENESS',
  CAMPAIGN_GOAL_TYPE_OFFLINE_ACTION: 'CAMPAIGN_GOAL_TYPE_OFFLINE_ACTION',
  CAMPAIGN_GOAL_TYPE_ONLINE_ACTION: 'CAMPAIGN_GOAL_TYPE_ONLINE_ACTION'
}

export const DV360_CAMPAIGN_GOAL_OPTIONS = [
  { label: i18n.t('CAMPAIGN_GOAL_TYPE_APP_INSTALL'), value: DV360_CAMPAIGN_GOAL_VALUES.CAMPAIGN_GOAL_TYPE_APP_INSTALL },
  { label: i18n.t('CAMPAIGN_GOAL_TYPE_BRAND_AWARENESS'), value: DV360_CAMPAIGN_GOAL_VALUES.CAMPAIGN_GOAL_TYPE_BRAND_AWARENESS },
  { label: i18n.t('CAMPAIGN_GOAL_TYPE_OFFLINE_ACTION'), value: DV360_CAMPAIGN_GOAL_VALUES.CAMPAIGN_GOAL_TYPE_OFFLINE_ACTION },
  { label: i18n.t('CAMPAIGN_GOAL_TYPE_ONLINE_ACTION'), value: DV360_CAMPAIGN_GOAL_VALUES.CAMPAIGN_GOAL_TYPE_ONLINE_ACTION }
]

export const DV360_PERFORMANCE_GOAL_VALUES = {
  PERFORMANCE_GOAL_TYPE_CPA: 'PERFORMANCE_GOAL_TYPE_CPA',
  PERFORMANCE_GOAL_TYPE_CPC: 'PERFORMANCE_GOAL_TYPE_CPC',
  PERFORMANCE_GOAL_TYPE_CPM: 'PERFORMANCE_GOAL_TYPE_CPM',
  PERFORMANCE_GOAL_TYPE_CTR: 'PERFORMANCE_GOAL_TYPE_CTR',
  PERFORMANCE_GOAL_TYPE_VIEWABILITY: 'PERFORMANCE_GOAL_TYPE_VIEWABILITY',
  PERFORMANCE_GOAL_TYPE_OTHER: 'PERFORMANCE_GOAL_TYPE_OTHER'
}

export const DV360_PERFORMANCE_GOAL_OPTIONS = [
  { label: i18n.t('PERFORMANCE_GOAL_TYPE_CPA'), value: DV360_PERFORMANCE_GOAL_VALUES.PERFORMANCE_GOAL_TYPE_CPA },
  { label: i18n.t('PERFORMANCE_GOAL_TYPE_CPC'), value: DV360_PERFORMANCE_GOAL_VALUES.PERFORMANCE_GOAL_TYPE_CPC },
  { label: i18n.t('PERFORMANCE_GOAL_TYPE_CPM'), value: DV360_PERFORMANCE_GOAL_VALUES.PERFORMANCE_GOAL_TYPE_CPM },
  { label: i18n.t('PERFORMANCE_GOAL_TYPE_CTR'), value: DV360_PERFORMANCE_GOAL_VALUES.PERFORMANCE_GOAL_TYPE_CTR },
  { label: i18n.t('PERFORMANCE_GOAL_TYPE_VIEWABILITY'), value: DV360_PERFORMANCE_GOAL_VALUES.PERFORMANCE_GOAL_TYPE_VIEWABILITY },
  { label: i18n.t('PERFORMANCE_GOAL_TYPE_OTHER'), value: DV360_PERFORMANCE_GOAL_VALUES.PERFORMANCE_GOAL_TYPE_OTHER }
]

export const DV360_FRECUENCY_CAP_PERIOD_VALUES = {
  TIME_UNIT_LIFETIME: 'TIME_UNIT_LIFETIME',
  TIME_UNIT_MONTHS: 'TIME_UNIT_MONTHS',
  TIME_UNIT_WEEKS: 'TIME_UNIT_WEEKS',
  TIME_UNIT_DAYS: 'TIME_UNIT_DAYS',
  TIME_UNIT_HOURS: 'TIME_UNIT_HOURS',
  TIME_UNIT_MINUTES: 'TIME_UNIT_MINUTES'
}

export const DV360_FRECUENCY_CAP_PERIOD_OPTIONS = [
  { label: i18n.t('TIME_UNIT_LIFETIME'), value: DV360_FRECUENCY_CAP_PERIOD_VALUES.TIME_UNIT_LIFETIME },
  { label: i18n.t('TIME_UNIT_MONTHS'), value: DV360_FRECUENCY_CAP_PERIOD_VALUES.TIME_UNIT_MONTHS },
  { label: i18n.t('TIME_UNIT_WEEKS'), value: DV360_FRECUENCY_CAP_PERIOD_VALUES.TIME_UNIT_WEEKS },
  { label: i18n.t('TIME_UNIT_DAYS'), value: DV360_FRECUENCY_CAP_PERIOD_VALUES.TIME_UNIT_DAYS },
  { label: i18n.t('TIME_UNIT_HOURS'), value: DV360_FRECUENCY_CAP_PERIOD_VALUES.TIME_UNIT_HOURS },
  { label: i18n.t('TIME_UNIT_MINUTES'), value: DV360_FRECUENCY_CAP_PERIOD_VALUES.TIME_UNIT_MINUTES }
]

export const DV360_PACING_PERIOD_VALUES = {
  PACING_PERIOD_DAILY: 'PACING_PERIOD_DAILY',
  PACING_PERIOD_FLIGHT: 'PACING_PERIOD_FLIGHT'
}

export const DV360_PACING_PERIOD_OPTIONS = [
  { label: i18n.t('PACING_PERIOD_DAILY'), value: DV360_PACING_PERIOD_VALUES.PACING_PERIOD_DAILY },
  { label: i18n.t('PACING_PERIOD_FLIGHT'), value: DV360_PACING_PERIOD_VALUES.PACING_PERIOD_FLIGHT }
]

export const DV360_PACING_TYPE_VALUES = {
  PACING_TYPE_EVEN: 'PACING_TYPE_EVEN',
  PACING_TYPE_ASAP: 'PACING_TYPE_ASAP',
  PACING_TYPE_AHEAD: 'PACING_TYPE_AHEAD'
}

export const DV360_PACING_TYPE_OPTIONS = [
  { label: i18n.t('PACING_TYPE_EVEN'), value: DV360_PACING_TYPE_VALUES.PACING_TYPE_EVEN },
  { label: i18n.t('PACING_TYPE_ASAP'), value: DV360_PACING_TYPE_VALUES.PACING_TYPE_ASAP },
  { label: i18n.t('PACING_TYPE_AHEAD'), value: DV360_PACING_TYPE_VALUES.PACING_TYPE_AHEAD }
]

const DV360_URL_PREFIX = '/google_ads/dv360'

const timestamp = new Date().getTime()

export default {
  async getCreatives () {
    const data = await api.get(`${DV360_URL_PREFIX}/creatives?${timestamp}`).then(res => res.data)
    return data.map(d => ({
      label: d.display_name,
      value: d.id
    }))
  },
  async getTargetTypes () {
    const data = await api.get(`${DV360_URL_PREFIX}/target_types?${timestamp}`).then(res => res.data)
    return data.map(d => ({
      label: d.name,
      value: d.name
    }))
  },
  async getCampaigns () {
    const data = await api.get(`${DV360_URL_PREFIX}/campaigns?${timestamp}`).then(res => res.data)
    return data.map(d => ({
      ...d,
      // Serialize wrong fields to match with the app
      bugget: d.planned_spend_amount,
      finish_date: d.end_date,
      // Props for select
      label: d.name,
      value: d.campaign_id
    }))
  },
  async getInsertionOrders (campaignId) {
    const data = await api.get(`${DV360_URL_PREFIX}/campaigns/${campaignId}/insertion_orders?${timestamp}`).then(res => res.data)
    return data.map(d => ({
      ...d,
      label: d.name,
      value: d.insertion_order_id
    }))
  }
}
